import { render } from "./emp_face_recognization.vue?vue&type=template&id=20b13b1a&scoped=true"
import script from "./emp_face_recognization.vue?vue&type=script&lang=js"
export * from "./emp_face_recognization.vue?vue&type=script&lang=js"

import "./emp_face_recognization.vue?vue&type=style&index=0&id=20b13b1a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b13b1a"]])

export default __exports__